import { VALUE_UNRESOLVED } from '../../Consts/backoffice.const';
import {
  PermissionGrantResponse,
  RoleDetailResponse,
} from '../../Interfaces/api/backoffice/rbac.interface';
import { PermissionGrant } from './permission-grant.model';

export class RoleSummary {
  id = '';
  name: string | null = null;
  organization_id: string | null = null;
  organization_name: string | null = null;
  is_read_only = false;
  intune_group: string | null = null;
  permissions_count = 0;
  users_count = 0;
  created_at: string | null = null;
  updated_at: string | null = null;
  permissions: PermissionGrant[] = [];

  constructor(data: Partial<RoleDetailResponse> = {}) {
    const grants = data.permissions ?? [];

    Object.assign(this, data);

    this.permissions = grants.map((grant: PermissionGrantResponse) => new PermissionGrant(grant));
  }

  get displayName(): string {
    return this.name || this.id;
  }

  get organizationLabel(): string {
    return this.organization_name || this.organization_id || VALUE_UNRESOLVED;
  }

  get scopeablePermissions(): PermissionGrant[] {
    return this.permissions.filter((permission) => permission.is_scopeable);
  }
}
